import requestData, {setFormData,setURLSearchParams,middleErrorInfo,formatterData} from "@/http/request";
import VueCookies from 'vue-cookies';
const thisFile = 'AddressRequest.js';
const shoppingCart = 'Address'.toLowerCase();
export function getAddressList() {
    return requestData('/purchase/getAddressList');
}
export function doAjaxSetDefAddress(addressId=0) {
    if(!addressId) return;
    return requestData('/purchase/doAjaxSetDefAddress','POST',{addressId});
}
export function doAjaxRemoveAddress(addressId=0){
    if(!addressId) return Promise.reject({msg:'addressId:'+addressId});
    VueCookies.get('currentSelectedAddressId')==addressId?VueCookies.remove('currentSelectedAddressId'):0;
    return requestData('/purchase/doAjaxRemoveAddress','POST',{addressId});
}
export function getAddressDetail(addressId=0){
    if(!addressId) return;
    return requestData('/purchase/getAddressDetail','POST',{addressId});
}
export function getProvince(type,arg){
    const data = {arg,type};
    for (const i in data) {
        if(!data[i]) delete data[i];
    }
    return requestData('/purchase/getProvince','POST',data);
}
export function doAjaxSaveAddress({
    lxr='',
    province=0,
    provinceName='',
    city=0,
    cityName='',
    detailAddress='',
    telephone='',
    phone='',
    email='',
    defaultAddress=1,
    county=0,
    addressId=null
}){
    const data = {
        lxr,
        province,
        provinceName,
        city,
        cityName,
        detailAddress,
        telephone,
        phone,
        email,
        defaultAddress,
        county
    };
    if(addressId) data['addressId'] = addressId;
    return requestData('/purchase/doAjaxSaveAddress','POST',data);
}